export default "/fonts/Ubuntu-Medium.woff2?454a7764db201ea9fccaf3ae71a405d8";